<template>
  <div class="animated">
    <div class="report_#">
      <b-card>
        <b-row>
          <b-col md="2">
            <b-form-group>
              * Please Set Range
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">From </label>
                <date-picker style="width: 300px" v-model="From" :lang="custom.lang.en" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">To </label>
                <date-picker style="width: 300px" v-model="To" :lang="custom.lang.en" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="report"> Search </b-button>
          <b-button size="sm" variant="success" id="excelHtml5" @click="printNow"> Print </b-button>
          <b-button size="sm" variant="warning" @click="save" :disabled="show">
            <span v-if="show"><Socket style="width : 18pt; height : 14pt;"></Socket></span>
            <span v-else>Save</span>
          </b-button>
        </b-form-group> -->
      </b-card>
      <div style="display:block; margin-left:auto; margin-right:auto;"><br>
      <h1 align="center" style="font-weight:700; font-size:50px">WEBCastle</h1>
      </div>
      <img style="display:block; margin-left:auto; margin-right:auto;" src="./world_map.png"/>
      <b-card>
        <b-form-group>
        Copyrights<br><br>
        Copyright ⓒ 2019 F1Security Inc.<br>
        Address (08507)<br>
        All Rights Reserved.<br><br>

        This report is intended to provide F1-WEBCastle personnel with information on the results of web application firewall operations during the period<br>
        This document is copyrighted by F1Security Inc. Because it is copyrighted in Korea under copyright law<br>
        Reproduction in any manner whatsoever without permission is prohibited. Without the written consent of F1Security Inc.<br>
        Please note that you can not cite it in whole or in part. Unauthorized use may be subject to penalties under applicable law.<br>
        This document may contain technical inaccuracies or typographical errors.<br>
        Note) Please note that the contents of this document or the program can be modified or changed without prior notice.
        </b-form-group>
      </b-card>
    </div>
    <div class="report_#">
      <template style="page-break-before:always;"></template>
        <b-form-group>
          <h4 style="page-break-before:always;">Contents</h4>
        </b-form-group>
        <b-card>
          <b-form-group>
            1. Summary - Summary of main contents of period<br>
            &nbsp; &nbsp;1.1. General Infomation<br>
            &nbsp; &nbsp;1.2. WEBCastle Status<br>
            &nbsp; &nbsp;1.3. Total Number of Security Events<br>
            2. Daily detection and blocking content<br>
            &nbsp; &nbsp;2.1. Daily detections & blocks<br>
            <!-- &nbsp; &nbsp;2.2. Module specific detections and blocks<br> -->
            3. Detections and blocks per web server<br>
            &nbsp; &nbsp;3.1 Top 10 targets<br>
            &nbsp; &nbsp;3.2 Top 10 attacker
          </b-form-group>
        </b-card>
      <b-form-group>
        <h5>1. Summary</h5>
        <small>
          {{From | date}} ~ {{To | date}} Indicates the number of modules installed over a period, the number of modules deleted, the number of detections and blocks, and the total number of modules
        </small>
      </b-form-group>
        <b-card>
            1.1. General Infomation
          <div lass="panel-body">
            <table style="width:100%; max-width:100%; border:1px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Username</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{auth.profile.username || 'F1 WEBCastle'}}</th>
                </tr>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Period</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{`${From} ~ ${To}`}}</th>
                </tr>
              </tbody>
            </table>
          </div>
            1.2. WebCaslte Status
          <div lass="panel-body">
            <table style="width:100%; max-width:100%; border:1px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Item</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">Count</th>
                </tr>
                <!-- <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Contracted</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray"> </th>
                </tr> -->
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Installed</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{model.agent.enable | number}}</th>
                </tr>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Removed</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{model.agent.disable | number}}</th>
                </tr>
              </tbody>
            </table>
          </div>
            1.3. Total Number of Security Events
          <div lass="panel-body">
            <table style="width:100%; max-width:100%; border:1px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Item</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">Count</th>
                </tr>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Detected</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{model.detect | number}}</th>
                </tr>
                <tr>
                  <th style="width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray">Blocked</th>
                  <th style="width:300px; padding:4px; background-Color:#f0f3f5; text-align: center; border-top: 1px solid gray">{{model.block | number}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
    </div>
    <div class="report_#">
      <b-form-group>
        <h4>2. Daily detection and blocking content</h4>
        <small>
          {{From | date}} ~ {{To | date}} Shows the change in the number of detections and blocks day.
        </small>
      </b-form-group>
      <template style="page-break-before:always;"></template>
      <b-card>
        <template slot="header">
            2.1 Daily detections & blocks
        </template>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <line-chart :messages="{ empty: 'Unable to check' }" :legend="true" :label="'Daily Detections & Blocks'" :discrete="true" :data="model.daily" :library="{ Axis: { format: 'YYYY-MM-dd' } }" :colors="['#ffc107', '#ff0029']"></line-chart>
              <!-- <line-chart :data="model.daily"></line-chart> -->
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="report_#">
      <b-form-group style="page-break-before:always;">
        <h5>3. Detections and blocks per web server</h5>
        <small>
          {{From | date}} ~ {{To | date}}
          Shows the total number of detections and blocking by each server where WEBCastle is installed. target servers and attacker IP address
        </small>
      </b-form-group>
     <b-card>
      <template slot="header">
        3.1 Total Number per Web Server
      </template>
      <div class="panel-body">
        <div>
          <table style="width:100%; max-width:100%; margin-bottom:20px; border-spacing: 0; border-collapse: collapse; border: 1px solid; text-align:center;" v-if="model && model.agents && model.agents.length">
            <tbody>
              <tr>
                <th style=" width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray;">Server Name</th>
                <th style=" width:300px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray;">Detected</th>
                <th style=" width:180px; padding:4px; background-Color:#c3b1b1; text-align: center; border-top: 1px solid gray;">Blocked</th>
              </tr>
              <tr v-for="(item, index) in model.agents" v-bind:key="index">
                <th style=" width:300px; padding:4px; background-Color:#fff; text-align: center; border-top: 1px solid gray;">
                  <del v-if="item.del">{{item.name}} ({{item.ip_addr}})</del>
                  <template v-else>{{item.name}} ({{item.ip_addr}})</template>
                </th>
                <th style=" width:180px; padding:4px; background-Color:#fff; text-align: center; border-top: 1px solid gray;">{{ item.total - item.block | number }}</th>
                <th style=" width:300px; padding:4px; background-Color:#fff; text-align: center; border-top: 1px solid gray;">{{ item.block | number }}</th>
              </tr>
            </tbody>
          </table>
          <div v-else class="text-center" style="color:#aaa;">
            No data were retrieved within the period
          </div>
        </div>
        </div>
      </b-card>
    </div>
    <div class="report_#">
      <b-card style="page-break-before:always;">
      <template slot="header">
        3.2 Top 10 attacked web servers
      </template>
      <b-row>
        <b-col md="12">
          <b-form-group>
            <bar-chart :messages="{ empty: 'No data were retrieved within the period' }" :data="model.target" :legend="true" :colors="['#f8eb51']" :label="'Attack count'" :discrete="true"></bar-chart>

          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card style="page-break-before:always;">
      <template slot="header">
        3.3 Top 10 Attacker`s IP Address
      </template>
      <b-row>
        <b-col md="12">
          <b-form-group>
            <bar-chart :messages="{ empty: 'No data were retrieved within the period' }" :data="model.attacker" :legend="true" :colors="['#dd0000']" :label="'Attack count'" :discrete="true"></bar-chart>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    </div>
  </div>
</template>

<script>
// import { idle } from '@/f1/service';;
// import { Socket } from 'vue-loading-spinner'
import moment from 'moment-timezone';
import custom from '@/f1/custom';
import DatePicker from 'vue2-datepicker';
import { api, auth } from '@/f1/service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import lineChart from './MainChart';

export default {
  components: { DatePicker },
  data: () => {
    return {
      auth,
      show : false,
      From: '',
      To: '',
      custom,
      rule_list : [],
      model : { block : 0, detect : 0, total : 0, agent : { total : 0, disable : 0, enable : 0 } , attacker : {}, target : {} }
    }
  },
  methods: {
    default(k) {
      let data = {}
      return data[`${key}`] = 0;
    },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      return api.agent.list().then(rs => { this.totalRows = rs.count; this.data = rs.count; return rs.rows; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText)(e.data));
    },
    //프린트 ctrl + p
    printNow(value){
      this.print = value;
      this.$nextTick(() => {
      window.print();
      });
    },
    async save() {
      try {
        this.$toastr.w("wait!!", "generate report")
        let gap = 5; // side padding
        let width = 210;
        let e = document.getElementsByClassName('report_#')
        let doc = new jsPDF('p', 'mm');
        var pageHeight = (width - gap) * 1.414;  // standard A4 paper
        let position = 5; // top padding
        for (let i = 0; i < e.length; i++) {
          let canvas = await html2canvas(e[i])
          this.show = true;
          let imgData = canvas.toDataURL('image/png');
          let imgHeight = canvas.height * width / canvas.width;
          let heightLeft = imgHeight;


          // add images
          doc.addImage(imgData, 'PNG', gap, position, width - (gap * 2), imgHeight);
          heightLeft -= pageHeight;
          position += imgHeight;

          // add the images over one pages
          while (heightLeft > 10) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', gap, position, width - (gap * 2), imgHeight);
            heightLeft -= pageHeight;
          }

          // start new page
          doc.addPage();
          position = 10;
        }
        doc.deletePage(doc.getNumberOfPages())
        this.show = false;
        doc.save(`[${this.From} - ${this.To}] F1 - WEBCastle Report.pdf`);
      } catch (e) { console.log(e) }
      // 캔버스를 이미지로 변환
    },
    report(){
      let m = {from : moment(this.From).format('YYYY-MM-DD'), to : moment(this.To).format('YYYY-MM-DD') }
      this.From = m.from; this.To = m.to;
      m.limit = 10;

      api.WebCastle_Call('report', 'report.web', m).then(rs => {

        // user info
        this.user = rs.body.summary.data.group;

        // daily detect, block
        this.model.daily = [ { name : "detect", data : [] }, { name : "block", data : [] }, ]
        _.forEach(rs.body.summary.data.result, r => {
          this.model.daily[0].data.push([r.date, r.total - r.block])
          this.model.daily[1].data.push([r.date, r.block])
        });

        // daily detect, block
        this.model.daily = [ { name : "detect", data : [] }, { name : "block", data : [] }, ]
        _.forEach(rs.body.summary.data.result, r => {
          this.model.daily[0].data.push([r.date, r.total - r.block])
          this.model.daily[1].data.push([r.date, r.block])
        });

        // target detect, block
        this.model.target = _.map(rs.body.summary.data.target, r => [r.target, r.total]);

        // attacker detect, block
        this.model.attacker = _.map(rs.body.summary.data.attacker, r => [r.attacker, r.total]);

        // module info
        this.model.agents = rs.body.recent.data.detect;

        // count of detect and block
        this.model.detect = 0;
        this.model.block = 0;
        this.model.total = 0;
        _.forEach(rs.body.summary.data.result, r => { this.model.total += r.total; this.model.block += r.block; });
        this.model.detect = this.model.total - this.model.block

        this.model.agent.total = 0;
        this.model.agent.enable = 0;
        this.model.agent.disable = 0;
        _.forEach(rs.body.summary.data.agent, r => { this.model.agent.total += r.total; this.model.agent.disable += r.del; });
        this.model.agent.enable = this.model.agent.total - this.model.agent.disable

        this.$toastr.i('Analysis Completed', 'report')

      }).catch(e => catch_msg(e));
    },
    catch_msg(e) { console.error(e); this.$toastr.e(e.data ? e.data.message : e.statusText); },
    hideList: function(e) {
      this.show = !e; console.log('report.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() {   console.log('report.vue', 'created'); },
  destroyed: function() {
    console.log('report.vue', 'destroyed');
  },
  mounted: function() {
    this.From = moment().add('days', location.hostname == "localhost" ? -30 : 0).format('YYYY-MM-DD');
    this.To = moment().add('days', 1).format('YYYY-MM-DD');
    this.report();
    console.log('report.vue', 'mounted'); },
}
</script>
